module.exports = __webpack_public_path__ + "static/clark-builders-logo-829ad195c198633ab44271970b2fc599.jpg";